<template>
    <el-collapse v-if="!notHasZjldComps.includes(curComponent.component)" v-model="attrActive" @change="handleAttrChange">
        <el-collapse-item name="wzsx">
            <template slot="title">
                <span>{{ $tt("位置属性") }}</span>
            </template>
            <slot name="wzsx" :isHideTitle="true"></slot>
        </el-collapse-item>
        <el-collapse-item name="zjsx">
            <template slot="title">
                <span>{{ $tt("组件属性") }}</span>
                <AttrHelpDot help-key="section.style" />
            </template>
            <slot name="zjsx" :isHideTitle="true"></slot>
        </el-collapse-item>
        <el-collapse-item name="zjld">
            <template slot="title">
                <span>{{ $tt("组件联动（预览生效）") }}</span>
                <span v-if="linkCount" class="tab-bind-badge">{{ linkCount }}</span>
                <AttrHelpDot help-key="section.componentLinks" />
            </template>
            <compLink></compLink>
        </el-collapse-item>
    </el-collapse>
    <div v-else>
        <slot name="wzsx"></slot>
        <slot name="zjsx"></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import compLink from './AttrComp/compLink';
import AttrHelpDot from './AttrHelpDot';
import { componentLinkCount } from "@/utils/canvasBindSummary";

export default {
    data() {
        return {
            attrActive: ['wzsx', 'zjsx'],
            hasTabComps: ['v-button', 'Picture', 'v-text', 'ChildPage'],
            notHasZjldComps: ['Back', 'Group']
        };
    },
    computed: {
        ...mapState([
            "curComponent"
        ]),
        linkCount() {
            return componentLinkCount(this.curComponent);
        },
    },
    components: {
        compLink,
        AttrHelpDot
    },
    methods: {
        handleAttrChange(val) {
            this.attrActive = val;
        }
    }
}
</script>
